module.exports = __webpack_public_path__ + "img/question_mark.875c115f.svg";